export default "__VITE_ASSET__DGJ4V073__"